import moment from "moment";

export const timeToDisplayString = (string = "00:00:00") => {
	let [h = "00", m = "00", s = "00"] = string.split(":");

	let displayString = "";

	if (h === "00" && m === "00") {
		displayString = `${s}s`;
	} else if (h === "00" && m !== "00" && s === "00") {
		displayString = `${m}m`;
	} else if (h === "00" && m !== "00") {
		displayString = `${m}m ${s}s`;
	} else {
		displayString = `${h}h ${m}m ${s}s`;
	}

	return `${displayString}`;
};

export const stringToMS = (string = "00:00:00") => {
	let [h, m, s = "00"] = string.split(":");

	return (parseInt(h) * 60 * 60 + parseInt(m) * 60 + parseInt(s)) * 1000;
};

export const msToString = (ms = 0) => {
	return moment.duration(ms, "milliseconds").format("HH[h] mm[m] ss[s]");
};

export const msToStringFormatted = (
	ms = 0,
	trim = true,
	format = "HH:mm:ss"
) => {
	return moment.duration(ms, "milliseconds").format(format, { trim });
};

export const sToStringFormatted = (s = 0) => {
	let ms = s * 1000;
	let hh = Math.floor(ms / 3600000) || 0;
	let mm = Math.floor((ms % 3600000) / 60000) || 0;
	let ss = Math.floor((ms % 60000) / 1000) || 0;
	const addZero = (num) => (num < 10 ? `0${num}` : num);
	return `${addZero(hh)}:${addZero(mm)}:${addZero(ss)}`;
};
